// extracted by mini-css-extract-plugin
module.exports = {"root":"fdDtX","text":"_3etjW"};